import React, { useMemo } from 'react';
import './_twig.files.menu.scss'
import './_twig.files.menu.dark-mode.scss'
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import TwigFilesGroup from './Group';

const TwigFilesList = ({
  files,
  isFullScreen,
}) => {
  const list = useMemo(() => {
    if (!files || isEmpty(files)) {
      return []
    }
    return Object.keys(files).map((title) => ({
      title,
      files: files[title],
    }))
  }, [files])

  return (
    <div className="twig-files-menu">
      {list.map((group, index) => (
        <TwigFilesGroup
          isFullScreen={isFullScreen}
          key={`group-${index}`}
          title={group.title}
          files={group.files}
        />
      ))}
    </div>
  );
}

TwigFilesList.propTypes = {
  files: PropTypes.array,
  isFullScreen: PropTypes.bool,
};

export default TwigFilesList;
